import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../../routes/routeName'
import ContainerButton from '../../../../components/button/ContainerButton'
import StateComponents from '../../../../components/state-component/StateComponents'
import { BoxChartsCustom } from '../../complaint/ComplaintStatistics'
import PieChart from '../../complaint/charts/PieChart'
import HorizontalChart from '../../complaint/charts/HorizontalChart'
import TableCustom from '../../../../components/table/tableCustom'
import { useTranslation } from 'react-i18next'
import { useMediaQuery, useTheme } from '@mui/material'
import moment from 'moment'
import StatusCustom from '../../../../components/status/statusCustom'
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom'
import TableRowCommon from '../../../../components/table/TableRowCommon'
import { chartStatisticsData, OnlineCourseApi } from '../../../../api/online-corse/online_course.api'
import { languageEnum } from '../../../../constants/enum'
import { type_user_data } from '../enum/enum'
import { getFileExtension } from '../../../../utils/fileTypeDownload'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import saveAs from 'file-saver'

const monthMap: Record<string, string> = {
    January: "มกราคม",
    February: "กุมภาพันธ์",
    March: "มีนาคม",
    April: "เมษายน",
    May: "พฤษภาคม",
    June: "มิถุนายน",
    July: "กรกฎาคม",
    August: "สิงหาคม",
    September: "กันยายน",
    October: "ตุลาคม",
    November: "พฤศจิกายน",
    December: "ธันวาคม"
};
type Props = {}

const CourseOnlineStatistics = (props: Props) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);

    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [type_user, set_type_user] = useState<string>("ALL");
    const [status_learning_data, set_learning_data] = useState<any[]>([]);

    const [month_categories, set_month_categories] = useState<string[]>([]);
    const [total_users, set_total_users] = useState<{ employee: number[], student: number[], member: number[] }>({
        employee: [],
        member: [],
        student: []
    })

    const [learning_type_data, set_learning_type_data] = useState<any[]>([
        {
            y: 0,
            name: "นักศึกษา",
            color: "#FFC772",
            type_user: "student"
        },
        {
            y: 0,
            name: "ผู้ใช้ทั่วไป",
            color: "#2D9CDB",
            type_user: "member"
        },
        {
            y: 0,
            name: "บุคลากร",
            color: "#90BE6D",
            type_user: "employee"
        },
    ]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 80, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 100, align: "center", label: "รหัสคอร์สเรียน"
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 100, label: "ชื่อคอร์สเรียน"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 100, label: "ยอดผู้เรียน"
        },
        {
            id: "status", disablePadding: false, align: "center", width: 100, label: "ยอดผู้ซื้อ"
        },
        // {
        //     id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 160, class: matches && data.length > 0, label: "สถานะ"
        // },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            online_course_name,
            online_course_no,
            user_free,
            user_pay
        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: online_course_no || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: online_course_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: user_free || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: user_pay || "-"
                },
                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     class: matches && data.length > 0,
                //     component: <div className='flex justify-between items-center'>
                //         <span>
                //             <StatusCustom
                //                 disableMaxWidth
                //                 text={"อยู่ระหว่างเรียน"}
                //                 type={"อยู่ระหว่างเรียน"}
                //             />
                //         </span>
                //     </div>
                // },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: chartStatisticsData = {}
        if (start_date) query = { ...query, start_date: moment(start_date).format("YYYY-MM-DD") }
        if (end_date) query = { ...query, end_date: moment(end_date).format("YYYY-MM-DD") }
        if (type_user !== 'ALL') query = { ...query, type_user: type_user }
        await OnlineCourseApi.getChart(query).then((res) => {
            if (res.status < 300) {
                const data = res.data || null
                const count_lern_mem: any[] = data?.count_lern_mem || [];
                const order_sum: any[] = data?.order_sum || [];
                const list_course_awesome = data?.list_course_awesome?.items || []
                const list_course_awesome_total_items = data?.list_course_awesome?.meta?.totalItems || []
                const study_status = data?.study_status || [];
                set_learning_data(study_status);
                setData(list_course_awesome);
                setTotalItems(list_course_awesome_total_items)
                if (count_lern_mem?.length > 0) {
                    set_learning_type_data((prev) => prev.map((list) => {
                        const data_value = count_lern_mem?.find((x) => x?.type_user === list?.type_user)?.count_user || 0
                        return {
                            ...list,
                            y: data_value ? +data_value : 0
                        }
                    }))
                }
                if (order_sum.length > 0) {
                    const groupedByUserType = order_sum.reduce((acc, item) => {
                        const { user_type } = item;
                        if (!acc[user_type]) {
                            acc[user_type] = [];
                        }
                        acc[user_type].push(item);
                        return acc;
                    }, {});
                    const month_data = currentLanguage === languageEnum.EN ?
                        groupedByUserType?.employee?.map((list: any) => list?.month_name) || [] :
                        groupedByUserType?.employee?.map((list: any) => monthMap[list?.month_name]) || []

                    set_month_categories(month_data);
                    set_total_users({
                        employee: groupedByUserType?.employee?.map((list: any) => Number(list?.payment_amount || 0)) || [],
                        member: groupedByUserType?.member?.map((list: any) => Number(list?.payment_amount || 0)) || [],
                        student: groupedByUserType?.student?.map((list: any) => Number(list?.payment_amount || 0)) || []
                    })
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [currentLanguage, page, pageLimit, type_user, start_date, end_date])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])
    const handleDownloadFile = async () => {

        let query: chartStatisticsData = {}
        if (start_date) query = { ...query, start_date: moment(start_date).format("YYYY-MM-DD") }
        if (end_date) query = { ...query, end_date: moment(end_date).format("YYYY-MM-DD") }
        if (type_user !== 'ALL') query = { ...query, type_user: type_user }
        dispatch(setLoading());

        await OnlineCourseApi.getChartFile(query).then((res) => {
            if (res.status < 300) {
                const response = res.data;
                // Get the content type from the server's response headers
                const contentType = res.headers["content-type"];

                // Create a Blob with the content type from the response
                const blob = new Blob([response], { type: contentType });

                // Extract file extension based on content type
                const fileExtension = getFileExtension(contentType || "");

                // Generate a filename with the correct extension (you can also modify this to use a custom name)
                const fileName = `${"statistics" + new Date().getTime()
                    }.${fileExtension}`;

                // Save the file
                saveAs(blob, fileName);
            }
        })
            .catch((error) => console.log(error))
            .finally(() => dispatch(unsetLoading()));
    };
    return (
        <ContainerLayout
            title='สถิติ'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "",
                            name: "จัดการข้อมูลคอร์สออนไลน์",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "",
                            name: "สถิติ",
                            pathName: routeName.cms.course_online_statistics,
                        },
                    ]}
                />
            }
            // TODO รอเพิ่ม
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            key: "DOWNLOAD_CSV",
                            label: "ดาวน์โหลด Excel",
                            seq: 1,
                            buttonProps: {
                                onClick: () => {
                                    handleDownloadFile()
                                }
                            },
                            type: "DOWNLOAD_CSV",

                        }
                    ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onChange: (e) => set_start_date(e),
                                    placeholder: 'จากวันที่',
                                    allowClear: true,
                                    onClear: () => {
                                        set_start_date("");
                                        set_end_date("");
                                    },
                                    value: start_date
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    disableStartDate: start_date,
                                    onChange: (e) => set_end_date(e),
                                    placeholder: 'ถึงวันที่',
                                    allowClear: true,
                                    onClear: () => set_end_date(""),
                                    disabled: !start_date,
                                    value: end_date
                                }
                            },
                            {
                                seq: 3,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    placeholder: "ประเภทผู้ใช้งาน",
                                    getOptionLabel: (op) => op.label,
                                    labelId: "type_user_data",
                                    onChange: (_, val) => set_type_user(val?.value),
                                    options: [{
                                        label: "ทั้งหมด",
                                        value: 'ALL'
                                    }, ...type_user_data],
                                    value: [{
                                        label: "ทั้งหมด",
                                        value: 'ALL'
                                    }, ...type_user_data].find((x) => x.value === type_user) || null
                                }
                            },
                            // {
                            //     seq: 4,
                            //     type: "AUTO-COMPLETE",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 3
                            //     },
                            //     fieldProps: {
                            //         placeholder: "ทุกสถานะ",
                            //         getOptionLabel: () => "",
                            //         labelId: "",
                            //         onChange: () => { },
                            //         options: [],
                            //         value: null
                            //     }
                            // },
                        ]}
                    />


                    <div className='grid grid-cols-12 mt-10 gap-4'>
                        <span className='col-span-12 lg:col-span-4'>
                            <BoxChartsCustom>
                                <span className='w-full bg-[#4A4A4A] text-white text-xl h-[60px] flex justify-start px-4 items-center rounded-t-[20px]'>
                                    {"จำนวนผู้เรียนแยกตามประเภท"}
                                </span>
                                <span className='my-10'>
                                    <PieChart
                                        innerSize='50%'
                                        data={learning_type_data || []}
                                    />
                                </span>
                            </BoxChartsCustom>
                        </span>
                        <span className='col-span-12 lg:col-span-8'>
                            <BoxChartsCustom>
                                <span className='w-full bg-[#4A4A4A] text-white text-xl h-[60px] flex justify-start px-4 items-center rounded-t-[20px]'>
                                    {"ยอดการใช้งาน"}
                                </span>
                                <span className='my-10'>
                                    <HorizontalChart
                                        categories={month_categories || []}
                                        data={[1, 2, 3, 4]}
                                        series={[
                                            {
                                                type: "column",
                                                color: "#FFC772",
                                                data: total_users.student,
                                                name: "นักศึกษา"
                                            },
                                            {
                                                type: "column",
                                                color: "#2D9CDB",
                                                data: total_users.member,
                                                name: "ผู้ใช้ทั่วไป"
                                            },
                                            {
                                                type: "column",
                                                color: "#90BE6D",
                                                data: total_users.employee,
                                                name: "บุคลากร"
                                            },
                                        ]}
                                        column
                                    />
                                </span>
                            </BoxChartsCustom>
                        </span>
                        <span className='col-span-12 lg:col-span-4'>
                            <BoxChartsCustom>
                                <span className='w-full bg-[#4A4A4A] text-white text-xl h-[60px] flex justify-start px-4 items-center rounded-t-[20px]'>
                                    {"สถานะการเรียน"}
                                </span>
                                <span className='my-10'>
                                    <PieChart
                                        innerSize='50%'
                                        data={
                                            status_learning_data?.map((list) => {
                                                return {
                                                    y: list?.course_total ? +list?.course_total : 0,
                                                    name: list?.ocp_online_course_user_status === 'progress' ?
                                                        'อยู่ระหว่างเรียน' : list?.ocp_online_course_user_status === 'succeed' ? 'สำเร็จ' : 'ยกเลิก',
                                                    color: list?.ocp_online_course_user_status === 'progress' ?
                                                        '#F79009' : list?.ocp_online_course_user_status === 'succeed' ? '#0F9F0C' : '#E80000',

                                                }
                                            })
                                            // [
                                            //     {
                                            //         y: 1,
                                            //         name: "อยู่ระหว่างเรียน",
                                            //         color: "#F79009"
                                            //     },
                                            //     {
                                            //         y: 2,
                                            //         name: "สำเร็จ",
                                            //         color: "#0F9F0C"
                                            //     },
                                            //     {
                                            //         y: 10,
                                            //         name: "ยกเลิก",
                                            //         color: "#E80000"
                                            //     },
                                            // ]
                                        }
                                    />
                                </span>
                            </BoxChartsCustom>
                        </span>
                        <span className='col-span-12 lg:col-span-8'>
                            <TableCustom
                                // tableMinWidth={1440}
                                // tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.slice(
                                    (page - 1) * pageLimit,
                                    ((page - 1) * pageLimit) + pageLimit
                                )?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </span>
                    </div>
                </div>
            }
        />
    )
}

export default CourseOnlineStatistics